import { render, staticRenderFns } from "./ServiceDetail.vue?vue&type=template&id=ad20fae8&"
import script from "./ServiceDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports